<template>
  <div class="layout_footer">
    <div class="footer_bottom">
      <div class="content">
        <P>版权所有：北京市中华职业教育培训中心</P>
        <P class="hidden-xs-only">
          地址：北京市东城区安乐林路甲69号   邮编：100075   电话：010-67270234 
           邮箱：zjsjyzx@163.com
        </P>
        <p
          class="hidden-sm-only hidden-sm-only hidden-md-only hidden-lg-only hidden-xl-only"
        >
          地址：北京市东城区安乐林路甲69号   邮编：100075 
          <br /> 电话：010-67270234   邮箱：zjsjyzx@163.com
        </p>
        <P>技术支持：北京泉江科技有限责任公司</P>
      </div>
    </div>
    <!-- <div class="footer_top">技术支持：北京泉江科技有限责任公司</div> -->
  </div>
</template>
<script>
export default {
  name: "layout-footer",
  data() {
    return {};
  },
};
</script>
<style scoped lang="less">
@media (min-width: 1200px) {
  .layout_footer {
    min-width: 1200px;
  }
}
@media (min-width: 768px) {
  .layout_footer {
    min-width: 100%;
  }
}
.layout_footer {
  font-size: 14px;
  color: #fff;
  .footer_top {
    height: 60px;
    line-height: 60px;
    text-align: center;
    background: #0e130f;
  }

  .footer_bottom {
    height: 140px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #2c3845;
    .content {
      P {
        text-align: center;
        line-height: 32px;
        margin: 0;
        padding: 0;
      }
    }
  }
}
</style>